import React, { useEffect, useState } from 'react';
import { Container, Table, Form, Button, Row, Col, Pagination, Badge, Modal } from 'react-bootstrap';
import { collection, deleteDoc, doc, getDoc, getDocs, query, serverTimestamp, updateDoc, where } from 'firebase/firestore';
import { db } from '../FireBase'; // Adjust the import path as needed
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import * as XLSX from 'xlsx'; // Import xlsx for Excel export
import '../css/font.css';
import { FaRightLong, FaTrash } from 'react-icons/fa6';
import GenerateReceipt from '../components/GenerateReceipt';
import ToastAlert from '../components/ToastAlert';
import Loading from '../components/Loading';
import { faL } from '@fortawesome/free-solid-svg-icons';

const Transaction = () => {
    const [transactions, setTransactions] = useState([]);
    const [error, setError] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;
    const [transactionData, setTransactionData] = useState(null);
    const [showReceipt,setShowReceipt]= useState(false);
   const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('success');
    const [loading, setLoading] = useState(true);
   
    const [statusFilter, setStatusFilter] = useState('All');



    useEffect(() => {
      
    
        fetchTransactions();
    }, []);
      const fetchTransactions = async () => {
        try {
            setLoading(true);
            const transactionRef = collection(db, 'transactions'); // Adjust to your Firestore collection name
            const snapshot = await getDocs(transactionRef);
            const transactionData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            
            // Sort transactions by date in descending order
            transactionData.sort((a, b) => {
                const dateA = a.paymentDate?.seconds ? new Date(a.paymentDate.seconds * 1000) : new Date(0);
                const dateB = b.paymentDate?.seconds ? new Date(b.paymentDate.seconds * 1000) : new Date(0);
                return dateB - dateA;
            });

            setTransactions(transactionData);
            console.log(transactionData);
        } catch (err) {
            setError('Failed to fetch transactions');
            console.error(err);
        }finally{
            setLoading(false);
        }
    };
   
    // Filter transactions based on the search query and date range
    const filteredTransactions = transactions.filter(transaction => {
        const transactionDate = transaction.paymentDate?.seconds
          ? new Date(transaction.paymentDate.seconds * 1000)
          : null;
      
        const isWithinDateRange =
          (!startDate || transactionDate >= new Date(startDate)) &&
          (!endDate   || transactionDate <= new Date(endDate));
      
        const matchesSearch =
          (transaction.transactionId?.toLowerCase() || '')
            .includes(searchQuery.toLowerCase()) ||
          (transaction.schemeId?.toLowerCase() || '')
            .includes(searchQuery.toLowerCase()) ||
          (transaction.userId?.toLowerCase() || '')
            .includes(searchQuery.toLowerCase());
      
        const matchesStatus =
          statusFilter === 'All' ||
          transaction.status === statusFilter;
      
        return isWithinDateRange && matchesSearch && matchesStatus;
      });
      
    const totalPages = Math.ceil(filteredTransactions.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredTransactions.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const downloadReport = () => {
        // Data for the transactions sheet
        const transactionsSheet = {
            name: 'Transactions',
            data: [
                ['Time Stamp', 'Transaction ID', 'Scheme ID', 'Customer ID', 'Amount', 'Payment Type'],
                ...transactions.map(transaction => [
                    transaction.paymentDate?.seconds ? new Date(transaction.paymentDate.seconds * 1000).toLocaleString() : 'N/A',
                    transaction.transactionId,
                    transaction.schemeId,
                    transaction.userId,
                    transaction.paymentAmount,
                    transaction.paymentType
                ])
            ]
        };

        // Create a new workbook
        const wb = XLSX.utils.book_new();

        // Create the transactions sheet
        const wsTransactions = XLSX.utils.aoa_to_sheet(transactionsSheet.data);
        XLSX.utils.book_append_sheet(wb, wsTransactions, transactionsSheet.name);

        // Write the workbook to a file
        XLSX.writeFile(wb, 'Transactions_Report.xlsx');
    };

    const downloadFilteredReport = () => {
        setLoading(true);
        // Data for the filtered transactions sheet
        const filteredTransactionsSheet = {
            name: 'Filtered Transactions',
            data: [
                ['Time Stamp', 'Transaction ID', 'Scheme ID', 'Customer ID', 'Amount', 'Payment Type'],
                ...filteredTransactions.map(transaction => [
                    transaction.paymentDate?.seconds ? new Date(transaction.paymentDate.seconds * 1000).toLocaleString() : 'N/A',
                    transaction.transactionId,
                    transaction.schemeId,
                    transaction.userId,
                    transaction.paymentAmount,
                    transaction.paymentType
                ])
            ]

        };

        // Create a new workbook
        const wb = XLSX.utils.book_new();

        // Create the filtered transactions sheet
        const wsFilteredTransactions = XLSX.utils.aoa_to_sheet(filteredTransactionsSheet.data);
        XLSX.utils.book_append_sheet(wb, wsFilteredTransactions, filteredTransactionsSheet.name);

        // Write the workbook to a file
        XLSX.writeFile(wb, 'Filtered_Transactions_Report.xlsx');
        setLoading(false);
    };
    
const handleDelete = async (id) => {
    // 1) confirm
    if (!window.confirm('Are you sure you want to delete this transaction?')) {
      return;
    }
  
    try {
        setLoading(true);
      // 2) delete the Firestore doc
      await deleteDoc(doc(db, 'transactions', id));
  
      // 3) update local state
      setTransactions(prev => prev.filter(tx => tx.id !== id));
  
      // optional: show a message
      setToastMessage("Transaction detail deleted!");
      setToastVariant('danger');
      setShowToast(true);

    } catch (error) {
      console.error('Error deleting transaction:', error);
     
    }finally{
        setLoading(false);
    }
  };
      
   
const handleMarkPaid = async (transactionId) => {
    try {
        setLoading(true);
      // 1️⃣ Load the transaction
      const txRef  = doc(db, 'transactions', transactionId);
      const txSnap = await getDoc(txRef);
      if (!txSnap.exists()) throw new Error('Transaction not found');
      const tx = txSnap.data();
        console.log(tx)
          
     if(tx.paymentType ==='Additional quantity purchase' || tx.paymentType === 'Joining fee'){
        await updateDoc(txRef, {
            status: 'Paid',
            paidAt: serverTimestamp()
          });
          fetchTransactions();
          setToastMessage("Payment verified!");
          setToastVariant('success');
          setShowToast(true);
          return;
     }
      // 2️⃣ Mark the transaction PAID

  
      // 3️⃣ Find the matching subscription
      const subsQ    = query(
        collection(db, 'subscriptions'),
        where('userId',   '==', tx.userId),
        where('schemeId', '==', tx.schemeId)
      );
      const subsSnap = await getDocs(subsQ);
      if (subsSnap.empty) throw new Error('Subscription not found');
      const subsDoc  = subsSnap.docs[0];
      const subsRef  = subsDoc.ref;
      const subData  = subsDoc.data();
  
      // 4️⃣ Update only the paid month in the payments array
      const updatedPayments = subData.payments.map(p =>
        p.monthName === tx.paymentMonth
          ? {
              ...p,
              paymentStatus: 'Paid',
              paidTimestamp: new Date().toISOString(),
            }
          : p
      );
      const newTransaction = {
      

        transactionId : tx.transactionId,
        schemename: tx.schemename,
        totalpaid:(subData.paidMonths || 0) + 1,
        overallmonths:subData.totalMonths,
        Quantity:subData.quantity,
        schemeId: tx.schemeId,
        userId: tx.userId,
        paymentAmount: tx.paymentAmount,
        paymentDate: tx.paymentDate,
        paymentType: tx.paymentType,
        paidFor:tx.paidFor,
    };
        await updateDoc(txRef, {
        status: 'Paid',
        paidAt: serverTimestamp()
      });
  
      // 5️⃣ Increment paidMonths and write back
      await updateDoc(subsRef, {
        paidMonths:   (subData.paidMonths || 0) + 1,
        payments:     updatedPayments,
        updatedAt:    serverTimestamp(),
        isActiveBy:   'System'
      });
     
      setTransactionData(newTransaction);
      setShowReceipt(true);
      
      <GenerateReceipt transaction={transactionData} />
      fetchTransactions();
      setToastMessage("Payment verified!");
      setToastVariant('success');
      setShowToast(true);
    } catch (err) {
      console.error('Error in mark-as-paid:', err);
      // Optional: toast error
    }finally{
        setLoading(false);
    }
  };
  const recModalClose = () => {
    setShowReceipt(false);
    setTransactionData('');
  }
  if (loading) {
    // Render loading screen
    
    return (
      <div className="loading-screen">
        
      <Loading/>
      </div>
    );
  }
    return (
        <Container fluid >
              <ToastAlert
                show={showToast}
                setShow={setShowToast}
                message={toastMessage}
                variant={toastVariant}
            />
            <br />
            <h1>Transactions</h1>
            <Row>
                <Col md={6}>
                    <Form className="mb-3">
                        <label>Search</label>
                        <Form.Control
                            type="text"
                            placeholder="Search transactions"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </Form>
                </Col>
                <Col md={2}>
                <Form className="mb-3">
                <label>Status</label>
                <Form.Control
                    as="select"
                    value={statusFilter}
                    onChange={e => {
                    setStatusFilter(e.target.value);
                    setCurrentPage(1);
                    }}
                >
                    <option value="All">All</option>
                    <option value="Pending-payment">Pending-payment</option>
                </Form.Control>
                </Form>
            </Col>
                <Col md={4}>
                    <Form className="mb-3">
                        <Row>
                            <Col>
                                <label>From Date</label>
                                <Form.Control
                                    type="date"
                                    placeholder="Start Date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </Col>
                            <Col>
                                <label>End Date</label>
                                <Form.Control
                                    type="date"
                                    placeholder="End Date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
                <Button variant='outline-secondary' className='mb-3' onClick={downloadFilteredReport}>Download Report</Button>
            <Table striped bordered hover>
                <thead>
                    <tr className='scheme-det-font-head'>
                        <th>Time stamp</th>
                        <th>Transaction ID</th>
                        <th>Razorpay ID</th>
                        <th>Scheme ID</th>
                        <th>Customer ID</th>
                        <th>Amount</th>
                        <th>Payment Type</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {currentItems.length > 0 ? (
                        currentItems.map(transaction => (
                            <tr key={transaction.id} className='scheme-det-font'>
                                <td>
                                    {transaction.paymentDate?.seconds ? new Date(transaction.paymentDate.seconds * 1000).toLocaleString() : 'N/A'}
                                </td>
                                <td>{transaction.transactionId}</td>
                                <td>{transaction.razorpayPaymentId || 'N/A'}</td>
                                <td><Link to={`/scheme/${transaction.schemeId}`} style={{ textDecoration: 'none', color: 'blue' }}>{transaction.schemeId}</Link></td>
                                <td><Link to={`/customerdetails/${transaction.userId}`} style={{ textDecoration: 'none', color: 'blue' }}>{transaction.userId}</Link></td>
                                <td>{transaction.paymentAmount}</td>
                                <td>
                                  <Badge 
                                        bg={
                                            transaction.paymentType === 'Manual Payment'
                                                ? 'warning'
                                                : (transaction.paymentType === 'Monthly Payment' || transaction.paymentType === 'Online payment')
                                                    ? 'success'
                                                    : 'info'
                                        }
                                    >
                                        {transaction.paymentType}
                                    </Badge>
                                </td>
                                <td><Badge 
                                        bg={transaction.status === 'Pending-payment' ? 'warning' : 'success'}
                                    >{transaction.status}</Badge>
                                    {transaction.status === 'Pending-payment' && (
                                        <>
                                            <Button
                                            variant="outline-danger"
                                            size="sm"
                                            className="ms-2"
                                            onClick={() => handleDelete(transaction.id)}
                                            >
                                            <FaTrash  className="fa-icon" /> 
                                            </Button>
                                            {!['Additional quantity purchase', 'Joining fee'].includes(transaction.paymentType) && (
                                                <Button
                                                    variant="outline-success"
                                                    size="sm"
                                                    className="ms-2"
                                                    onClick={() => handleMarkPaid(transaction.id)}
                                                >
                                                    <FaRightLong className="fa-icon" />
                                                </Button>
                                                )}


                                           
                                            </>
                                    )}
                                    
                                    </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="6">No transactions found.</td>
                        </tr>
                    )}
                </tbody>
            </Table>
                            <Pagination>
                {currentPage > 3 && (
                    <>
                    <Pagination.Item onClick={() => paginate(1)}>1</Pagination.Item>
                    <Pagination.Ellipsis disabled />
                    </>
                )}

                {Array.from({ length: 5 }, (_, i) => {
                    const page = currentPage - 2 + i;
                    if (page > 0 && page <= totalPages) {
                    return (
                        <Pagination.Item
                        key={page}
                        active={page === currentPage}
                        onClick={() => paginate(page)}
                        >
                        {page}
                        </Pagination.Item>
                    );
                    }
                    return null;
                })}

                {currentPage < totalPages - 2 && (
                    <>
                    <Pagination.Ellipsis disabled />
                    <Pagination.Item onClick={() => paginate(totalPages)}>{totalPages}</Pagination.Item>
                    </>
                )}
                </Pagination>
                <Modal show={showReceipt} onHide={recModalClose}centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Receipt</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {showReceipt && transactionData &&  (
                        <div>
                            <center>
                            <GenerateReceipt transaction={transactionData} />
                            </center>
                        </div>
                        )}
                        </Modal.Body>
                    </Modal>
        </Container>
    );
};

export default Transaction;